if (!customElements.get('ea-menu-drawer')) {
  customElements.define(
    'ea-menu-drawer',
    class EAMenuDrawer extends CustomDialog {
      constructor() {
        super();
        this.setupKeyboardNavigation();
        this.subMenus = this.querySelectorAll('.ea-menu-drawer__submenu');
      }

      setupKeyboardNavigation() {
        this.addEventListener('keydown', (event) => {
          const focusableElements = this.querySelectorAll(
            '.ea-menu-drawer__summary, .ea-menu-drawer__link, .ea-menu-drawer__secondary-link, .ea-menu-drawer__close, button:not([disabled]), a[href]',
          );
          const focusableArray = Array.from(focusableElements).filter((el) => {
            return (
              el.offsetParent !== null ||
              el.closest('details[open]') !== null ||
              !el.closest('details') ||
              el.matches('summary')
            );
          });
          const currentIndex = focusableArray.indexOf(document.activeElement);

          switch (event.code) {
            case 'ArrowDown':
              event.preventDefault();
              if (currentIndex < focusableArray.length - 1) {
                focusableArray[currentIndex + 1].focus();
              } else {
                focusableArray[0].focus();
              }
              break;
            case 'ArrowUp':
              event.preventDefault();
              if (currentIndex > 0) {
                focusableArray[currentIndex - 1].focus();
              } else {
                focusableArray[focusableArray.length - 1].focus();
              }
              break;
            case 'Home':
              event.preventDefault();
              focusableArray[0]?.focus();
              break;
            case 'End':
              event.preventDefault();
              focusableArray[focusableArray.length - 1]?.focus();
              break;
            case 'Escape':
              this.closeDialog();
              break;
          }
        });

        this.querySelectorAll('.ea-menu-drawer__summary').forEach((summary) => {
          summary.addEventListener('click', (event) => {
            this.subMenus.forEach((submenu) => {
              submenu.classList.remove('opened');
            });
            event.target.nextElementSibling.classList.toggle('opened');
          });
        });

        // Handle Enter/Space on summary elements to expand and focus first child
        // this.addEventListener('keydown', (event) => {
        //   if (
        //     event.target.matches('.ea-menu-drawer__summary') &&
        //     (event.code === 'Enter' || event.code === 'Space')
        //   ) {
        //     // Let the native details toggle happen, then focus first item
        //     setTimeout(() => {
        //       const details = event.target.closest('details');
        //       if (details && details.open) {
        //         const firstLink = details.querySelector(
        //           '.ea-menu-drawer__submenu .ea-menu-drawer__link, .ea-menu-drawer__submenu .ea-menu-drawer__summary',
        //         );
        //         if (firstLink) firstLink.focus();
        //       }
        //     }, 0);
        //   }
        // });
      }

      openDialog(e) {
        // Only open if the hamburger menu toggle is visible
        // This ensures we match the dynamic behavior of when mobile nav should be active
        const menuToggle = document.querySelector('.menu-drawer__toggle');
        if (menuToggle) {
          const isToggleVisible =
            window.getComputedStyle(menuToggle).display !== 'none';
          if (!isToggleVisible) {
            return;
          }
        }

        super.openDialog();

        // Open the first menu item by default
        this.subMenus.forEach((submenu) => submenu.classList.remove('opened'));
        const firstSubmenu = this.querySelector(
          '.ea-menu-drawer__item .ea-menu-drawer__submenu',
        );
        if (firstSubmenu) firstSubmenu.classList.add('opened');

        if (Shopify?.designMode) return;
        const animation = { opacity: [0, 1] };
        // if (!window.matchMedia(`(prefers-reduced-motion: reduce)`).matches) {
        //   animation.transform = ['translateX(-100%)', 'translateX(0)'];
        // }
        this.querySelector('.ea-menu-drawer__dialog-window').animate(
          animation,
          { duration: 300, easing: 'ease' },
        );
      }

      closeDialog(e) {
        super.closeDialog();
        this.querySelectorAll('localization-form').forEach((form) => {
          form.hidePanel(true);
        });
        // this.querySelector('.ea-menu-drawer__details[open]').animate(
      }
    },
  );
}
